@app.service 'csFlexDropdownManager', [->
  dropdowns = []
  this.addScope = (dropdown) ->
    dropdowns.push dropdown

  this.open = (scope) ->
    angular.forEach dropdowns, (dropdown) ->
      unless dropdown.$id == scope.$id
        dropdown.menuOpen = false

  return this
]

@app.directive 'csFlexDropdown', ($document, csFlexDropdownManager, $rootScope) ->
  scope: {}
  controller: ['$scope', ($scope) ->
    csFlexDropdownManager.addScope $scope

    $scope.menuOpen = false

    toggleMenu: ->
      $scope.menuOpen = ! $scope.menuOpen
      $rootScope.$safeApply()
  ]

  link: (scope, element, attrs) ->
    elem = element[0]
    dropdown = angular.element(elem.querySelector('.flex-dropdown-menu'))
    scope.$watch 'menuOpen', (newValue, oldValue) ->
      if newValue == true
        element.addClass 'active'
        element.removeClass 'inactive'
        dropdown.addClass 'open'
        dropdown.removeClass 'closed'
        csFlexDropdownManager.open(scope)
      else
        element.removeClass 'active'
        element.addClass 'inactive'
        dropdown.removeClass 'open'
        dropdown.addClass 'closed'

    $document.on 'click', (e) ->
      scope.menuOpen = false
      $rootScope.$safeApply()

@app.directive 'csFlexDropdownToggle', [ ->
  require: '^csFlexDropdown'
  link: (scope, element, attrs, csFlexDropdownController) ->
    element.bind 'click', (e) ->
      csFlexDropdownController.toggleMenu()
      e.stopPropagation()
]
